import { getEncarteThemeSearchResult } from "../../../../../services/EncarteThemeService";

const BASE_URL = process.env.REACT_APP_RESOURCES_BASE_URL;
/**
 * Fetch encarte themes by days period (for start and end month themes).
 * @param {string} token - Auth token
 * @param {number} page - Page number (default 0)
 * @param {number} size - Page size (default 10, max 100)
 * @returns {Promise<ResourceSearchResult<EncarteTheme>>}
 */
export default function useFetchThemesByDaysPeriod() {
  const fetchThemesByDaysPeriod = async (token, page = 0, size = 10) => {
    const url = `${BASE_URL}/encartethemes/by-days-period?page=${page}&size=${size}`;
    const res = await fetch(url, {
      headers: { Authorization: token },
    });
    if (!res.ok) throw new Error("Failed to fetch themes by days period");
    const json = await res.json();
    return getEncarteThemeSearchResult(token, json);
  };
  return fetchThemesByDaysPeriod;
}
